import React, { Component } from "react";
import Header from "./header";
import Role from "./role";
import ClipboardCompoent from "./clipboardComponent";

import clipboardy from "clipboardy";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clipboard: false,
      copytext: "Click to Copy!",
    };
  }

  handleMouseLeave = () => {
    this.setState({ clipboard: false });
    this.setState({ copytext: "Click to Copy!" });
  };

  handleMouseEnter = () => {
    this.setState({ clipboard: true });
  };

  handleClick = async () => {
    try {
      await clipboardy.write("mail@sathish.dev");
      this.setState({ copytext: "Copied !" });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    return (
      <section className="main">
        <Header />
        <Role />
        <ClipboardCompoent {...this.state} captureMouseLeave={this.handleMouseLeave} captureMouseEnter={this.handleMouseEnter} captureClick={this.handleClick} />
      </section>
    );
  }
}

export default Main;
